// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.en3gmk0 {
  transition: opacity 100ms;
}
.en3gmk1 {
  font-size: var(--_18w76bw33);
  font-weight: var(--_18w76bw3e);
}
.en3gmk2 {
  font-size: var(--_18w76bw34);
  font-weight: var(--_18w76bw3d);
}
.en3gmk3 {
  font-size: var(--_18w76bw34);
  font-weight: var(--_18w76bw3e);
}
.en3gmk4 {
  font-size: var(--_18w76bw34);
  font-weight: var(--_18w76bw3g);
}
.en3gmk5 {
  font-size: var(--_18w76bw35);
  font-weight: var(--_18w76bw3d);
}
.en3gmk6 {
  font-size: var(--_18w76bw35);
  font-weight: var(--_18w76bw3e);
}
.en3gmk7 {
  font-size: var(--_18w76bw35);
  font-weight: var(--_18w76bw3g);
}
.en3gmk8 {
  font-size: var(--_18w76bw35);
  font-weight: var(--_18w76bw3g);
}
.en3gmk9 {
  font-size: var(--_18w76bw36);
  font-weight: var(--_18w76bw3e);
}
.en3gmka {
  font-size: var(--_18w76bw36);
  font-weight: var(--_18w76bw3g);
}
.en3gmkb {
  font-size: var(--_18w76bw37);
  font-weight: var(--_18w76bw3d);
}
.en3gmkc {
  font-size: var(--_18w76bw37);
  font-weight: var(--_18w76bw3e);
}
.en3gmkd {
  font-size: var(--_18w76bw37);
  font-weight: var(--_18w76bw3g);
}
.en3gmke {
  font-size: var(--_18w76bw38);
  font-weight: var(--_18w76bw3d);
}
.en3gmkf {
  font-size: var(--_18w76bw38);
  font-weight: var(--_18w76bw3e);
}
.en3gmkg {
  font-size: var(--_18w76bw39);
  font-weight: var(--_18w76bw3e);
}
.en3gmkh {
  font-size: var(--_18w76bw39);
  font-weight: var(--_18w76bw3g);
}
.en3gmki {
  font-size: var(--_18w76bw3a);
  font-weight: var(--_18w76bw3d);
  line-height: var(--_18w76bw3j);
}
.en3gmkj {
  font-size: var(--_18w76bw3a);
  font-weight: var(--_18w76bw3e);
  line-height: var(--_18w76bw3j);
}
.en3gmkk {
  font-size: 48px;
  font-weight: var(--_18w76bw3h);
}
.en3gmkl {
  font-size: 32px;
  font-weight: var(--_18w76bw3g);
}
.en3gmkm {
  font-size: 28px;
  font-weight: var(--_18w76bw3g);
}
.en3gmkn {
  font-size: var(--_18w76bw35);
  color: var(--_18w76bw22);
}
.en3gmkn:hover, .en3gmkn:focus {
  cursor: pointer;
  color: var(--_18w76bw21);
  text-decoration: underline;
}
.en3gmkp {
  transition: color 200ms, opacity 200ms;
}
.en3gmkp:hover {
  opacity: 0.65;
}
@media screen and (max-width: 767px) {
  .en3gmk8 {
    font-size: var(--_18w76bw34);
  }
  .en3gmkb {
    font-size: var(--_18w76bw36);
    font-weight: var(--_18w76bw3e);
  }
  .en3gmkh {
    font-size: var(--_18w76bw38);
    font-weight: var(--_18w76bw3g);
  }
  .en3gmki {
    font-size: var(--_18w76bw38);
    font-weight: var(--_18w76bw3e);
  }
  .en3gmkj {
    font-size: var(--_18w76bw38);
    font-weight: var(--_18w76bw3e);
  }
  .en3gmkk {
    font-size: 30px;
  }
  .en3gmkl {
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".en3gmk0 {\n  transition: opacity 100ms;\n}\n.en3gmk1 {\n  font-size: var(--_18w76bw33);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmk2 {\n  font-size: var(--_18w76bw34);\n  font-weight: var(--_18w76bw3d);\n}\n.en3gmk3 {\n  font-size: var(--_18w76bw34);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmk4 {\n  font-size: var(--_18w76bw34);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmk5 {\n  font-size: var(--_18w76bw35);\n  font-weight: var(--_18w76bw3d);\n}\n.en3gmk6 {\n  font-size: var(--_18w76bw35);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmk7 {\n  font-size: var(--_18w76bw35);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmk8 {\n  font-size: var(--_18w76bw35);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmk9 {\n  font-size: var(--_18w76bw36);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmka {\n  font-size: var(--_18w76bw36);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmkb {\n  font-size: var(--_18w76bw37);\n  font-weight: var(--_18w76bw3d);\n}\n.en3gmkc {\n  font-size: var(--_18w76bw37);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmkd {\n  font-size: var(--_18w76bw37);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmke {\n  font-size: var(--_18w76bw38);\n  font-weight: var(--_18w76bw3d);\n}\n.en3gmkf {\n  font-size: var(--_18w76bw38);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmkg {\n  font-size: var(--_18w76bw39);\n  font-weight: var(--_18w76bw3e);\n}\n.en3gmkh {\n  font-size: var(--_18w76bw39);\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmki {\n  font-size: var(--_18w76bw3a);\n  font-weight: var(--_18w76bw3d);\n  line-height: var(--_18w76bw3j);\n}\n.en3gmkj {\n  font-size: var(--_18w76bw3a);\n  font-weight: var(--_18w76bw3e);\n  line-height: var(--_18w76bw3j);\n}\n.en3gmkk {\n  font-size: 48px;\n  font-weight: var(--_18w76bw3h);\n}\n.en3gmkl {\n  font-size: 32px;\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmkm {\n  font-size: 28px;\n  font-weight: var(--_18w76bw3g);\n}\n.en3gmkn {\n  font-size: var(--_18w76bw35);\n  color: var(--_18w76bw22);\n}\n.en3gmkn:hover, .en3gmkn:focus {\n  cursor: pointer;\n  color: var(--_18w76bw21);\n  text-decoration: underline;\n}\n.en3gmkp {\n  transition: color 200ms, opacity 200ms;\n}\n.en3gmkp:hover {\n  opacity: 0.65;\n}\n@media screen and (max-width: 767px) {\n  .en3gmk8 {\n    font-size: var(--_18w76bw34);\n  }\n  .en3gmkb {\n    font-size: var(--_18w76bw36);\n    font-weight: var(--_18w76bw3e);\n  }\n  .en3gmkh {\n    font-size: var(--_18w76bw38);\n    font-weight: var(--_18w76bw3g);\n  }\n  .en3gmki {\n    font-size: var(--_18w76bw38);\n    font-weight: var(--_18w76bw3e);\n  }\n  .en3gmkj {\n    font-size: var(--_18w76bw38);\n    font-weight: var(--_18w76bw3e);\n  }\n  .en3gmkk {\n    font-size: 30px;\n  }\n  .en3gmkl {\n    font-size: 26px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
